import { render } from "./ICFVideos.vue?vue&type=template&id=d5749894&scoped=true"
import script from "./ICFVideos.js?vue&type=script&lang=js"
export * from "./ICFVideos.js?vue&type=script&lang=js"

import "./ICFVideos.vue?vue&type=style&index=0&id=d5749894&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5749894"]])

export default __exports__